import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function Benefits() {
  const ref = useScrollAnimation();
  const benefits = [{
    icon: '⏰',
    title: 'Ahorrá 1 año entero',
    description: 'Todo listo para usar. Sin armar nada desde cero.'
  }, {
    icon: '📋',
    title: 'Currículo argentino',
    description: 'Alineado a los NAP y diseños curriculares vigentes.'
  }, {
    icon: '🎯',
    title: 'Primaria y Secundaria',
    description: '12 tomos completos que cubren todos los niveles.'
  }, {
    icon: '🔄',
    title: 'Actualizaciones gratis',
    description: 'Recibís mejoras y contenido nuevo sin costo extra.'
  }];
  return <section id="beneficios" className="w-full bg-[#0a0a0a] py-24 px-4 border-t border-[#1a1a1a] pt-[50px] pb-[50px]" ref={ref} data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="scroll-hidden text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-4">
            ¿Por qué elegir el Mega Pack?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-5">
          {benefits.map((benefit, index) => <div key={index} className="scroll-hidden bg-[#141414] border border-[#2a2a2a] rounded-xl p-8 text-center hover:-translate-y-1 transition-transform duration-300" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-6">
              <div className="text-5xl mb-6" data-id="element-7">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-8">
                {benefit.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-9">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}